import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISiteStudyPersonalState } from 'src/types/SiteStudyPersonal';

const initialState: ISiteStudyPersonalState = {
  isBacktoSitepersonnel: false
};

export const siteStudyPersonnel = createSlice({
  name: 'siteStudyPersonnel',
  initialState,
  reducers: {
    setStudyIdEnable: (state, action: PayloadAction<string>) => {
      state.study_id_enabled = action.payload;
      state.trackUpdate = undefined;
    },
    clearStudyIdEnabled: state => {
      state.study_id_enabled = undefined;
    },
    clearTrackUpdate: state => {
      state.trackUpdate = undefined;
    },
    setTrackUpdate: (state, action: PayloadAction<string>) => {
      state.trackUpdate = action.payload;
    },
    clearStudyState: state => {
      state.study_id_enabled = undefined;
      state.trackUpdate = undefined;
    },
    setIsbacktositepersonnel: (state, action: PayloadAction<boolean>) => {
      state.isBacktoSitepersonnel = action.payload;
    }
  }
});

export const {
  setStudyIdEnable,
  clearStudyIdEnabled,
  setTrackUpdate,
  clearTrackUpdate,
  clearStudyState,
  setIsbacktositepersonnel
} = siteStudyPersonnel.actions;
